export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Raison de suspension\",\n    \"label_other\": \"{{count}} raisons de suspension\"\n}\n"